import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

export default function PoemPending() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [msg, setMsg] = useState("Confirming your payment and composing your poem… (10–20 seconds)");

  useEffect(() => {
    if (!sessionId) {
      setMsg("Missing session. If you completed payment, please contact support.");
      return;
    }
    const finalize = async () => {
      try {
        const { data } = await api.post(`/poem/finalize/${sessionId}`);
        if (data?.is_paid && data?.redirect_url) {
          toast.success("Your customized poem is ready!");
          window.location.href = data.redirect_url;
        } else {
          setMsg("Payment not yet confirmed. Please refresh in a moment.");
        }
      } catch (e) {
        setMsg(e?.response?.data?.detail || "Could not finalize. Please contact support@obituaryrelief.com.");
      }
    };
    finalize();
  }, [sessionId]);

  return (
    <div style={{ maxWidth: 560, margin: "120px auto", padding: "0 24px", textAlign: "center" }} data-testid="poem-pending-page">
      <div style={{ fontSize: 64, marginBottom: 16 }}>🪶</div>
      <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 6 }}>CUSTOMIZED RHYMING POEM</div>
      <h1 className="serif" style={{ fontSize: 32, color: "#fff", margin: "0 0 18px", fontWeight: 400 }}>Composing your poem</h1>
      <p className="muted" style={{ fontSize: 15, lineHeight: 1.7 }}>{msg}</p>
    </div>
  );
}
